<!-- CRM System Layout -->
<div class="app-container">
  <!-- Network Status Banner -->
  <app-network-status-banner />
  
  <!-- Authenticated Layout -->
  @if (isLoggedIn$ | async) {
    <!-- Header -->
    <app-header></app-header>
    
    <!-- Main Content with Sidebar -->
    <app-sidebar>
      <router-outlet></router-outlet>
    </app-sidebar>

    <!-- Floating Calendar Button - jobb szélen, mozgatható -->
    <app-floating-calendar-button />
  } @else {
    <!-- Login Layout -->
    <router-outlet></router-outlet>
  }
</div>
